import { Typography } from "@mui/material"

const CustomHeader = props =>
    <Typography
        variant="h2"
        gutterBottom
        fontFamily='"Nunito Sans", sans-serif, Arial, Helvetica'
        sx={{
            color: props.color,
            fontWeight: 100,
            fontSize: { xs: 14, md: 18 },
            mb: 5
        }}
    >
        {props.title}
    </Typography>

export default CustomHeader